import type { JSX } from "react";
import type { IdProp } from "@charterindex/armoury-www";
import { Autocomplete, Stack, TextField, Typography } from "@mui/material";
import { useObservable } from "ecce-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../services/services-context";
import { CompanyIcon, PersonIcon } from "../../atoms/icons/mui-icons";
import { Form } from "../../atoms/form";


export type MasqueradeFormProps = IdProp & {
	disabled: boolean;
};
export const MasqueradeForm = ({ id, disabled }: MasqueradeFormProps): JSX.Element => {
	const { masqueradeController } = useAuth();
	useObservable(masqueradeController, "companyOptions");
	useObservable(masqueradeController, "selectedCompany");
	useObservable(masqueradeController, "peopleOptions");
	useObservable(masqueradeController, "selectedPerson");

	const { t } = useTranslation();

	return (
		<Form id={ id } onSubmit={ masqueradeController.submit }>
			<Stack>
				<Autocomplete
					options={ masqueradeController.companyOptions }
					value={ masqueradeController.selectedCompany }
					onChange={ (ev, value) => masqueradeController.selectCompany(value) }
					getOptionLabel={ c => c.name }
					renderOption={ (props, option) => (
						<Typography component="li" { ...props } key={ option.id }>
							{ option.name }
						</Typography>
					) }
					renderInput={ props => (
						<TextField
							{ ...props }
							label={ t("common:company") }
							slotProps={{
								...props.slotProps,
								input: {
									...props.slotProps?.input,
									startAdornment: <CompanyIcon/>,
								},
							}}
						/>
					) }
					disabled={ disabled }
				/>

				<Autocomplete
					options={ masqueradeController.peopleOptions }
					value={ masqueradeController.selectedPerson }
					onChange={ (ev, value) => masqueradeController.selectPerson(value) }
					getOptionLabel={ c => c.name }
					renderOption={ (props, option) => (
						<Typography component="li" { ...props } key={ option.id }>
							{ option.name }
						</Typography>
					) }
					renderInput={ props => (
						<TextField
							{ ...props }
							label={ t("common:user") }
							slotProps={{
								...props.slotProps.input,
								input: {
									...props.slotProps.input,
									startAdornment: <PersonIcon/>,
								},
							}}
						/>
					) }
					disabled={ disabled }
				/>
			</Stack>
		</Form>
	);
};
